import React from "react";
import Loading from "./Loading";
import { useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { ENDPOINTS } from '../config';
import image_arrow_left from '../img/arrow-left.png';
import "./Portfolio.css";

const Project = ({ visibility, functions, pageList, data, resetDrag, refreshPage }) => {
  const { category, project } = useParams();
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const divRef = useRef(null);

  useEffect(() => {
    if (!project) return;
    setLoading(true);
    setError(null);
    fetch(ENDPOINTS.projectContent(project))
      .then(res => res.ok ? res.json() : Promise.reject(new Error('Not found')))
      .then(data => {
        setProjectData(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setProjectData(null);
        setLoading(false);
      });
  }, [project, refreshPage]);

  const resolveImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `/admin/uploads/${url.replace(/^uploads\//, '')}`;
  };

  const backUrl = category ? `/portfolio/${category}` : '/portfolio';

  if (loading) {
    return (
      <div>
        <div id="content" className="region" style={{ display: 'block' }}>
          <div className="pageTitle" id="projectPageTitle">
            <h1>PORTFOLIO</h1>
            <h4>LOADING PROJECT...</h4>
          </div>
          <div id="pageLoader" style={{ opacity: 1 }}>
            <Loading />
          </div>
        </div>
      </div>
    );
  }

  if (error || !projectData) {
    return (
      <div>
        <div id="content" className="region" style={{ display: 'block' }}>
          <div className="pageTitle" id="projectPageTitle">
            <h1>PORTFOLIO</h1>
            <h4>PROJECT NOT FOUND</h4>
          </div>
          <div className="row project-container project-sections" ref={divRef}>
            <div className="project-back-link">
              <Link to={backUrl}>
                <motion.div
                  className="button-portfolio"
                  whileHover={{ scale: 1.1, opacity: 0.6 }}
                  whileTap={{ scale: 1.2, borderRadius: "100%" }}
                  style={{ color: 'white' }}
                >
                  <div className="col-md-1" style={{ width: '30px' }}>
                    <img src={image_arrow_left} alt="Back" />
                  </div>
                  <span>Back to Portfolio</span>
                </motion.div>
              </Link>
            </div>
            <div className="project-sections-content">
              <p className="project-empty">Project not found.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const sections = projectData.sections || [];

  return (
    <div>
      <div id="content" className="region" style={{ display: 'block' }}>
        <div className="pageTitle" id="projectPageTitle">
          <h1>PORTFOLIO</h1>
          <h4>{projectData.title}</h4>
        </div>
        <br />
        <div className="row project-container project-sections" ref={divRef}>
          <div className="project-back-link">
            <Link to={backUrl}>
              <motion.div
                className="button-portfolio"
                whileHover={{ scale: 1.1, opacity: 0.6 }}
                whileTap={{ scale: 1.2, borderRadius: "100%" }}
                style={{ color: 'white' }}
              >
                <div className="col-md-1" style={{ width: '30px' }}>
                  <img src={image_arrow_left} alt="Back" />
                </div>
                <span>Back to Portfolio</span>
              </motion.div>
            </Link>
          </div>
          {projectData.image_url && (
            <div className="project-hero-image">
              <img src={resolveImageUrl(projectData.image_url)} alt={projectData.title} />
            </div>
          )}
          {projectData.technologies && projectData.technologies.length > 0 && (
            <div className="project-technologies">
              {projectData.technologies.map((tech, i) => (
                <span key={i} className="project-tech-tag">{tech}</span>
              ))}
            </div>
          )}
          <div className="project-sections-content">
            {sections.length > 0 ? (
              sections.map((sec, i) => (
                <section key={sec.id || i} className="project-section">
                  {sec.title && <h2 className="project-section-title">{sec.title}</h2>}
                  <div
                    className="project-section-body"
                    dangerouslySetInnerHTML={{ __html: sec.content || '' }}
                  />
                </section>
              ))
            ) : (
              <p className="project-empty">No content yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
